// 将所有空白符去除
export function trimAll(str?: string) {
  return typeof str === 'string' ? `${str}`.replace(/\s/g, '') : str;
}

// 可以直接给 getValueFromEvent 方法赋值
export function trimInputAll(e: any) {
  const str = typeof e === 'object' && e ? e?.target?.value : e;
  return trimAll(str);
}

// 可以直接给 getValueFromEvent 方法赋值
export function trimInput(e: any) {
  const str = typeof e === 'object' && e ? e?.target?.value : e;
  return typeof str === 'string' ? `${str}`.trim() : str;
}

/** JSON parse */
export function safeParse(str: string, fallback?: any): any {
  let res = fallback;
  try {
    res = JSON.parse(str);
  } catch (error) {
    console.log(error);
  }
  return res;
}

/** JSON stringify */
export function safeStringify(obj: object, fallback = ''): string {
  let str = fallback;
  try {
    str = JSON.stringify(obj);
  } catch (error) {
    console.log(error);
  }
  return str;
}
